<template>
  <el-container>
    <MainSidebar :menu-items="menuItems" />
    <el-container
      direction="vertical"
      class="main-container"
    >
      <MainHeader v-if="$route.name !== 'postLogin'" />
      <el-main
        :class="[
          'main',
          { 'main--has-fab': !!this.$route.meta.hasFloatingActionButton },
          { 'main--has-background': $route.name === 'postLogin' },
        ]"
        :style="{
          backgroundImage:
            $route.name === 'postLogin'
              ? `url(${require('@/assets/images/background_preLogin.png')})`
              : '',
        }"
      >
        <el-container>
          <router-view />
        </el-container>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
  import { mapGetters } from 'vuex';

  import MainHeader from '@/components/MainHeader.vue';
  import MainSidebar from '@/components/MainSidebar.vue';
  import { menuItems } from '@/config';
  import auth from '@/services/auth';

  export default {
    name: 'PostLogin',
    components: {
      MainSidebar,
      MainHeader,
    },
    data() {
      return {
        menuItems,
      };
    },
    computed: {
      ...mapGetters(['loggedUser']),
    },
    watch: {
      loggedUser(newVal) {
        if (newVal === null) {
          auth.logout();
          this.$router.push({ name: 'Login' });
          this.$notify({
            showClose: true,
            type: 'success',
            message: this.$t('auth.logout.successMessage'),
          });
        }
      },
    },
  };
</script>

<style lang="scss">
  .main-container {
    height: 100vh;
    overflow-y: auto;

    .main {
      overflow: unset;

      &--has-background {
        background-repeat: no-repeat;
        background-position: bottom center;
        background-size: auto 70vh;
      }
    }
  }
</style>
